import * as React from 'react'

import { ENTITY_TYPES, IUser, SOLD_SERVICE_STATUS } from '@sales-center/common'
import { NextActionDate } from '@user/components/EntityCards/atoms/NextActionDate/NextActionDate'
import { OpportunityActions } from '../OpportunityActions/OpportunityActions'
import { OppStatus } from './typings'
import { ParentHeader as Container } from './styling'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import { ExpectedClosingDate } from '@user/components/EntityCards/atoms/ExpectedClosingDate'
import { OpportunityStatusSelect } from './OpportunityStatusSelect/OpportunityStatusSelect'
import { ActivitiesManager } from '@user/features/Activity'
import { IOpportunity } from '@user/store/opportunity'
import { Theme } from '@mui/material/styles'

interface Props {
  attachmentCount: number
  closedDate: Date | null
  closeWinDisabled: boolean
  closeWinErrors: string[]
  detailPage?: boolean
  expectedClosingDate: Date | null
  locationId: string
  nextActionDate: Date | null
  opportunityId: number
  salesFunnelId: number
  salesFunnelStageId: number
  oppStatus: OppStatus
  assignee: IUser | null
  branchId: string
  branch: string
  salesTeamId: number
  canUpdate: boolean
  canDelete: boolean
  soldServiceStatus: SOLD_SERVICE_STATUS
  opportunity: IOpportunity
}

export function ParentHeader(props: Props) {
  const { opportunityId: id, salesTeamId, assignee } = props

  return (
    <Container>
      <Stack
        sx={{ marginRight: (theme: Theme) => theme.spacing(2.4) }}
        direction="row"
        spacing={2}
      >
        <ActivitiesManager
          entityId={id}
          entityType={ENTITY_TYPES.Opportunity}
          salesTeamId={salesTeamId}
          ownerId={assignee?.id || null}
        />
        <NextActionDate
          id={props.opportunityId}
          nextActionDate={props.nextActionDate}
          disabled={!props.canUpdate}
        />
      </Stack>
      <Box>
        <ExpectedClosingDate
          id={props.opportunityId}
          disabled={!props.canUpdate}
          expectedClosingDate={props.expectedClosingDate}
          required
        />
      </Box>
      <Box display="flex" flex-direction="row" style={{ marginLeft: 'auto' }}>
        <Box sx={{ marginRight: (theme: Theme) => theme.spacing(1.2) }}>
          <OpportunityStatusSelect
            externalSvcLocId={props.locationId}
            disabled={!props.canUpdate}
            assigneeId={props.assignee?.id || null}
            {...props}
          />
        </Box>

        <Box sx={{ marginRight: (theme: Theme) => theme.spacing(-1.2) }}>
          <OpportunityActions
            {...props}
            closedDate={props.closedDate || null}
            assigneeId={props.assignee?.id || null}
          />
        </Box>
      </Box>
    </Container>
  )
}
